import type { RefreshOutcome } from '../data/useTemplateQuery';
import type { CustomizationAction } from '../state/actions';
import { LABEL_KEYS } from '../viewmodels/messages';

export function resolveRefreshAction(
  outcome: RefreshOutcome
): CustomizationAction {
  if (outcome.ok) {
    return { type: 'REPLICA_LOADED', template: outcome.template };
  }

  if (outcome.failure === 'notFound') {
    return { type: 'REPLICA_LOAD_FAILED', failure: 'notFound' };
  }

  return {
    type: 'REFRESH_FAILED',
    failure: {
      messageKey: LABEL_KEYS.recoveryRefreshFailedBody,
      cause: outcome.cause,
    },
  };
}
